import { render } from "./RTHistory.vue?vue&type=template&id=6b5d221d&scoped=true"
import script from "./RTHistory.vue?vue&type=script&lang=js"
export * from "./RTHistory.vue?vue&type=script&lang=js"

import "./RTHistory.vue?vue&type=style&index=0&id=6b5d221d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b5d221d"]])

export default __exports__